export default __webpack_public_path__ + "static/media/Ghostflight.0485c0f6.jpg";